import { CellBox } from "./CellBox";
import { EntityChips } from "../EntityChips";

export type CategoriesCellProps = {
  names: string[];
  pending: boolean;
  onClick: () => void;
};

export const CategoriesCell = ({
  names,
  pending,
  onClick,
}: CategoriesCellProps) => (
  <CellBox pending={pending} onClick={onClick}>
    <EntityChips type="category" names={names} />
  </CellBox>
);
